import React from 'react';
import './Filters.css';
import DateTimePicker from './DateTimePicker';

function Filters({ filters, onFilterChange, onReset, chains, sources }) {
  const handleChange = (key, value) => {
    onFilterChange({ [key]: value });
  };

  return (
    <div className="filters-container">
      <div className="filters-header">
        <h2>🔍 Filtres</h2>
        <button className="reset-btn" onClick={onReset}>
          ↻ Réinitialiser
        </button>
      </div>

      <div className="filters-grid">
        {/* Recherche */}
        <div className="filter-group">
          <label>🔎 Recherche</label>
          <input
            type="text"
            placeholder="Adresse, nom ou symbole..."
            value={filters.search}
            onChange={(e) => handleChange('search', e.target.value)}
          />
        </div>

        {/* Chaîne */}
        <div className="filter-group">
          <label>🔗 Chaîne</label>
          <select
            value={filters.chain}
            onChange={(e) => handleChange('chain', e.target.value)}
          >
            <option value="">Toutes</option>
            {chains.map((chain) => (
              <option key={chain} value={chain}>
                {chain.toUpperCase()}
              </option>
            ))}
          </select>
        </div>

        {/* Recommandation */}
        <div className="filter-group">
          <label>💡 Recommandation</label>
          <select
            value={filters.recommendation}
            onChange={(e) => handleChange('recommendation', e.target.value)}
          >
            <option value="">Toutes</option>
            <option value="ACHAT_AUTO">✅ Achat Auto</option>
            <option value="ACHAT_MANUEL">⚠️ Achat Manuel</option>
            <option value="REJET">❌ Rejet</option>
          </select>
        </div>

        {/* Honeypot */}
        <div className="filter-group">
          <label>🍯 Honeypot</label>
          <select
            value={filters.is_honeypot}
            onChange={(e) => handleChange('is_honeypot', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="true">⚠️ Oui</option>
            <option value="false">✅ Non</option>
          </select>
        </div>

        {/* Rug Pull */}
        <div className="filter-group">
          <label>🚨 Rug Pull</label>
          <select
            value={filters.is_rug}
            onChange={(e) => handleChange('is_rug', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="true">⚠️ Oui</option>
            <option value="false">✅ Non</option>
          </select>
        </div>

        {/* Risk Level */}
        <div className="filter-group">
          <label>⚡ Niveau de Risque</label>
          <select
            value={filters.risk_level}
            onChange={(e) => handleChange('risk_level', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="LOW">🟢 Faible</option>
            <option value="MEDIUM">🟡 Moyen</option>
            <option value="HIGH">🔴 Élevé</option>
          </select>
        </div>

        {/* Social */}
        <div className="filter-group">
          <label>🌐 Présence Sociale</label>
          <select
            value={filters.has_social}
            onChange={(e) => handleChange('has_social', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="true">✅ Oui</option>
            <option value="false">❌ Non</option>
          </select>
        </div>

        {/* Logo */}
        <div className="filter-group">
          <label>🎨 Logo</label>
          <select
            value={filters.has_logo}
            onChange={(e) => handleChange('has_logo', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="true">✅ Oui</option>
            <option value="false">❌ Non</option>
          </select>
        </div>

        {/* Liquidité Lockée */}
        <div className="filter-group">
          <label>🔒 Liquidité Lockée</label>
          <select
            value={filters.lp_locked}
            onChange={(e) => handleChange('lp_locked', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="true">✅ Oui</option>
            <option value="false">❌ Non</option>
          </select>
        </div>

        {/* Open Source */}
        <div className="filter-group">
          <label>📂 Open Source</label>
          <select
            value={filters.is_open_source}
            onChange={(e) => handleChange('is_open_source', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="true">✅ Oui</option>
            <option value="false">❌ Non</option>
          </select>
        </div>

        {/* Source de détection */}
        <div className="filter-group">
          <label>🛰️ Source</label>
          <select
            value={filters.source}
            onChange={(e) => handleChange('source', e.target.value)}
          >
            <option value="">Toutes</option>
            {(sources || []).map((src) => (
              <option key={src} value={src}>{src}</option>
            ))}
          </select>
        </div>

        {/* Ratio Achat/Vente */}
        <div className="filter-group">
          <label>📈 Ratio Achat/Vente</label>
          <select
            value={filters.buy_sell_ratio}
            onChange={(e) => handleChange('buy_sell_ratio', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="more_buys">🟢 Plus d'achats</option>
            <option value="more_sells">🔴 Plus de ventes</option>
            <option value="balanced">⚖️ Équilibré</option>
          </select>
        </div>

        {/* Volume de Transactions */}
        <div className="filter-group">
          <label>💹 Volume Transactions 24h</label>
          <select
            value={filters.txn_volume}
            onChange={(e) => handleChange('txn_volume', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="low">🔵 Faible (&lt; 50)</option>
            <option value="medium">🟡 Modéré (50-200)</option>
            <option value="high">🟢 Élevé (&gt; 200)</option>
            <option value="very_high">🔥 Très élevé (&gt; 500)</option>
          </select>
        </div>

        {/* Minimum Transactions d'Achat */}
        <div className="filter-group">
          <label>🛒 Min. Achats 24h</label>
          <input
            type="number"
            placeholder="Ex: 50"
            min="0"
            value={filters.min_txn_buys}
            onChange={(e) => handleChange('min_txn_buys', e.target.value)}
          />
        </div>

        {/* Minimum Transactions de Vente */}
        <div className="filter-group">
          <label>💰 Min. Ventes 24h</label>
          <input
            type="number"
            placeholder="Ex: 50"
            min="0"
            value={filters.min_txn_sells}
            onChange={(e) => handleChange('min_txn_sells', e.target.value)}
          />
        </div>

        {/* Minimum Transactions Totales */}
        <div className="filter-group">
          <label>📊 Min. Transactions 24h</label>
          <input
            type="number"
            placeholder="Ex: 100"
            min="0"
            value={filters.min_txn_total}
            onChange={(e) => handleChange('min_txn_total', e.target.value)}
          />
        </div>

        {/* Balance Équipe / Creator Balance */}
        <div className="filter-group">
          <label>👥 Balance Équipe</label>
          <select
            value={filters.team_balance}
            onChange={(e) => handleChange('team_balance', e.target.value)}
          >
            <option value="">Tous</option>
            <option value="excellent">🟢 Excellent (&lt; 5%)</option>
            <option value="good">✅ Bon (5-10%)</option>
            <option value="medium">🟡 Moyen (10-20%)</option>
            <option value="risky">🔴 Risqué (&gt; 20%)</option>
            <option value="very_risky">🚨 Très risqué (&gt; 50%)</option>
          </select>
        </div>

        {/* Date From */}
        <div className="filter-group">
          <label>📅 Date Début</label>
          <DateTimePicker
            value={filters.date_from}
            onChange={(val) => handleChange('date_from', val)}
          />
        </div>

        {/* Date To */}
        <div className="filter-group">
          <label>📅 Date Fin</label>
          <DateTimePicker
            value={filters.date_to}
            onChange={(val) => handleChange('date_to', val)}
          />
        </div>

        {/* Sort By */}
        <div className="filter-group">
          <label>📊 Trier Par</label>
          <select
            value={filters.sort_by}
            onChange={(e) => handleChange('sort_by', e.target.value)}
          >
            <option value="created_at">Date Création</option>
            <option value="updated_at">Date MAJ</option>
            <option value="score">Score</option>
          </select>
        </div>

        {/* Sort Order */}
        <div className="filter-group">
          <label>↕️ Ordre</label>
          <select
            value={filters.sort_order}
            onChange={(e) => handleChange('sort_order', e.target.value)}
          >
            <option value="desc">↓ Décroissant</option>
            <option value="asc">↑ Croissant</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default Filters;
